import type {
  SubgramStatusTask,
  SubgramTask,
  TaskDetails,
} from './adapters/subgramAdapter';
import { SubgramAdapter } from './adapters/subgramAdapter';
export enum SponsorType {
  BARZHA = 'barzha',
  TAPPADS = 'tappads',
  DREAMCOIN_CLICK = 'dreamcoin_click',
  DREAMCOIN_SUBSCRIBE = 'dreamcoin_subscribe',
  BARZHA_CLICK = 'barzha_click',
  FLYER = 'flyer',
  SUBGRAM = 'subgram',
  TADDY = 'taddy',
}
export class SponsorsTasksAdapter {
  static async adaptTasks(
    sponsorType: SponsorType,
    response: TaskDetails[] | unknown[],
    statusTasks?: SubgramStatusTask[],
  ): Promise<TaskDetails[]> {
    console.log('🔄 SponsorsTasksAdapter.adaptTasks - start', {
      sponsorType,
      response,
      statusTasks,
    });

    switch (sponsorType) {
      case SponsorType.SUBGRAM:
        return SubgramAdapter.adaptTasks(
          response as SubgramTask[],
          statusTasks as SubgramStatusTask[],
        );

      default:
        console.warn(`Unknown sponsor type: ${sponsorType}`);
        return [];
    }
  }
}
